import type { Floor, Site } from '../context/types';

export function getPinCoordinate(
  locationX: number,
  locationY: number,
  selectedFloor: Floor | undefined,
  selectedSite: Site | undefined,
  imgHeight: number,
  imgWidth: number,
  translation?: { x: number; y: number }, //make optional
  zoomLevel?: number, //make optional
) {
  const { bottom, left, right, top } =
    selectedFloor || selectedSite!.campus_map;

  const mapWidth = right - left;
  const mapHeight = top - bottom;
  const xScale = imgWidth / mapWidth;
  const yScale = imgHeight / mapHeight;

  const offsetX = locationX - left;
  const offsetY = top - locationY;
  let scaledX = offsetX * xScale;
  let scaledY = offsetY * yScale;

  const currentImgWidth = zoomLevel ? imgWidth * zoomLevel : imgWidth;
  const currentImgHeight = zoomLevel ? imgHeight * zoomLevel : imgHeight;

  scaledX = imgWidth !== 0 ? (scaledX / imgWidth) * currentImgWidth : 0;
  scaledY = imgHeight !== 0 ? (scaledY / imgHeight) * currentImgHeight : 0;

  scaledX -= translation ? translation.x : 0;
  scaledY -= translation ? translation.y : 0;

  return { x: scaledX, y: scaledY };
}
